var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loadingDialog,
      expression: "loadingDialog"
    }],
    staticClass: "alert-details-dialog",
    attrs: {
      "visible": _vm.dialogOpened,
      "width": _vm.width,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "destroy-on-close": "",
      "show-close": false
    },
    on: {
      "update:visible": function ($event) {
        _vm.dialogOpened = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function () {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function ($event) {
              return _vm.closeDialog();
            }
          }
        }, [_vm._v(_vm._s(_vm.LABEL_CANCEL))]), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "padding": "7.5px 12px"
          },
          attrs: {
            "type": "primary",
            "disabled": _vm.loadingDialog
          },
          on: {
            "click": function ($event) {
              return _vm.handleClick();
            }
          }
        }, [_vm._v(_vm._s(_vm.LABEL_YES_PROCEED))])];
      },
      proxy: true
    }])
  }, [_c('el-form', [_c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "title text-sm",
    staticStyle: {
      "line-height": "0px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/icons/warning-employement.svg")
    }
  })]), _vm.title ? _c('h3', {
    staticClass: "title text-sm mt-2 text-black"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _c('p', {
    staticClass: "description text-sm mt-4 break-normal",
    domProps: {
      "innerHTML": _vm._s(_vm.subtitle)
    }
  })])]), _vm._v(" "), _vm.details.length ? _c('div', {
    staticClass: "mt-6"
  }, [_c('ul', {
    staticClass: "details-selection"
  }, _vm._l(_vm.details, function (i) {
    return _c('li', {
      key: i,
      staticClass: "text-black"
    }, [_c('span', {
      staticClass: "details"
    }, [_vm._v(_vm._s(i))])]);
  }), 0)]) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }